import { tString } from 'components/translation/Translation';
import { withTranslation } from 'react-i18next';

const ClaimFormCheckboxes = ({ form, onChangeHelpReach, onChangeHelpReachOther }) => {
  const helpReach = [
    { id: 'growimg-your-prospective', label: tString('landing:landingForm.goalGrowPipeline') },
    { id: 'communicating-with-interested-students', label: tString('landing:landingForm.goalCommunication') },
    { id: 'boostin-student-enrollment', label: tString('landing:landingForm.goalBoost') },
    { id: 'raising-your-lead-to-enrollment-conversion-rate', label: tString('landing:landingForm.goalRaiseLead') },
    { id: 'increasing-your-schools-visibility', label: tString('landing:landingForm.goalVisibility') },
    { id: 'establishing-marketing-budget-plan', label: tString('landing:landingForm.goalMarketing') },
    { id: 'improving-your-digital-marketing-roi', label: tString('landing:landingForm.goalROI') },
    { id: 'automating-your-recruitment-efforts', label: tString('landing:landingForm.goalAutomation') },
    { id: 'providing-seamless-online-enrollment', label: tString('landing:landingForm.goalOnlineEnrollment') },
    { id: 'other', label: tString('landing:landingForm.goalOther') },
  ];
  return (
    <>
      <div className="col-6">
        <ul role="listbox">
          {helpReach.slice(0, helpReach.length / 2).map((elem) => {
            return (
              <div className="form-check" key={elem.id}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={elem.id}
                  onChange={(e) => onChangeHelpReach(elem)}
                />
                <label className="form-check-label" htmlFor={elem.id}>
                  {elem.label}
                </label>
              </div>
            );
          })}
        </ul>
      </div>
      <div className="col-6">
        <ul role="listbox">
          {helpReach.slice(helpReach.length / 2, helpReach.length).map((elem) => {
            return (
              <div className="form-check" key={elem.id}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={elem.id}
                  onChange={(e) => onChangeHelpReach(elem)}
                />
                <label className="form-check-label" htmlFor={elem.id}>
                  {elem.label}
                </label>
              </div>
            );
          })}
        </ul>
        <div className="form-group">
          <input
            className="form-control mt-2"
            id="otherTextarea1"
            onChange={(e) => onChangeHelpReachOther(elem)}
            value={form.otherHelpReach}
          />
        </div>
      </div>
    </>
  );
};

export default withTranslation()(ClaimFormCheckboxes);
